function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
import regeneratorRuntime from "regenerator-runtime";
import { defineComponent, computed, reactive, ref, watch } from "vue";
import DialogForm from "@/components/DialogForm/index.vue";
import { getDemandInfo, getDemandResult, submitDemand } from "@pt/api/demand";
import { definePropType } from "@types-vue/props";
import { Message } from "element-ui";
import BindProjectTable from "@pt/components/bind-project/bind-project-table.vue";
import PtButton from "@com/pt-components/pt-button/index.vue";
import { PtButtonTheme, PtButtonType } from "@com/pt-components/pt-button/enum";
export default defineComponent({
    name: "BindProjectBar",
    components: {
        PtButton: PtButton,
        BindProjectTable: BindProjectTable,
        DialogForm: DialogForm
    },
    props: {
        projectId: {
            type: Number,
            default: 0
        },
        disabled: {
            type: Boolean,
            default: false
        },
        source: {
            type: definePropType(String),
            default: "gm"
        },
        demandId: {
            type: Number,
            default: 0
        }
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var demandResultByIdPoll = function demandResultByIdPoll() {
            getDemandResultTimer && clearInterval(getDemandResultTimer);
            getDemandResultTimer = setInterval(function() {
                getDemandResultById();
            }, 3000);
        };
        var loading = ref(false);
        var bindProjectButton = computed(function() {
            return {
                disabled: props.disabled,
                loading: loading.value
            };
        });
        var demandTable = ref([]);
        var demandTableMessage = ref("");
        var demandProgress = ref("");
        var successMessage = null;
        var errorMessage = null;
        var getDemandResultTimer = null;
        var dialogConfig = reactive({
            title: "\u5173\u8054\u9700\u6C42",
            visible: false,
            width: "550px",
            loading: false,
            disabled: true,
            cancelLabel: "\u53D6\u6D88",
            confirmLabel: "\u786E\u5B9A",
            appendToBody: true
        });
        var dialogFormConfig = {
            labelWidth: "80px",
            labelPosition: "left"
        };
        var dialogTableConfig = reactive({
            visible: false,
            title: "\u63D0\u6D4B\u4EFB\u52A1\u5217\u8868",
            width: "1000px",
            loading: false,
            appendToBody: false,
            modalAppendToBody: false
        });
        var dialogValue = reactive({
            id: "",
            demander_name: "-",
            account_manager_name: "-",
            planner_name: "-",
            designer_name: "-",
            developer_name: "-",
            adv_name: "-",
            biz_scenario_name: "-",
            status: "",
            biz_scenario: 0,
            tips: "\u5173\u8054\u540E\u65E0\u6CD5\u53D6\u6D88\uFF0C\u8BF7\u786E\u8BA4\u9700\u6C42"
        });
        var DemandStatus = {
            Init: 0,
            Loading: 1,
            Success: 2,
            Fail: 3
        };
        // 0: init, 1: loading, 2: success, 3: error
        var demandStatus = ref(DemandStatus.Init);
        var resetDialog = function() {
            dialogConfig.disabled = true;
            demandStatus.value = DemandStatus.Init;
            dialogValue.id = "";
            dialogValue.demander_name = "-";
            dialogValue.account_manager_name = "-";
            dialogValue.planner_name = "-";
            dialogValue.designer_name = "-";
            dialogValue.developer_name = "-";
            dialogValue.adv_name = "-";
            dialogValue.biz_scenario_name = "-";
            dialogValue.status = "";
            dialogValue.biz_scenario = 0;
            dialogValue.tips = "\u5173\u8054\u540E\u65E0\u6CD5\u53D6\u6D88\uFF0C\u8BF7\u786E\u8BA4\u9700\u6C42";
        };
        watch(function() {
            return dialogConfig.visible;
        }, function(value, oldValue) {
            if (value && !oldValue) {
                resetDialog();
            }
        });
        var getDemandInfoById = function() {
            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
                var res;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            if (dialogValue.id) {
                                _ctx.next = 2;
                                break;
                            }
                            return _ctx.abrupt("return");
                        case 2:
                            _ctx.prev = 2;
                            demandStatus.value = DemandStatus.Loading;
                            _ctx.next = 6;
                            return getDemandInfo({
                                id: Number(dialogValue.id)
                            });
                        case 6:
                            res = _ctx.sent;
                            if (res.data.code === 0) {
                                demandStatus.value = DemandStatus.Success;
                                dialogConfig.disabled = false;
                                dialogValue.demander_name = res.data.data.demander_name;
                                dialogValue.account_manager_name = res.data.data.account_manager_name;
                                dialogValue.planner_name = res.data.data.planner_name;
                                dialogValue.designer_name = res.data.data.designer_name;
                                dialogValue.developer_name = res.data.data.developer_name;
                                dialogValue.adv_name = res.data.data.adv_name;
                                dialogValue.biz_scenario_name = res.data.data.biz_scenario_name;
                                dialogValue.status = res.data.data.status;
                                dialogValue.biz_scenario = res.data.data.biz_scenario;
                            } else {
                                demandStatus.value = DemandStatus.Fail;
                            }
                            _ctx.next = 13;
                            break;
                        case 10:
                            _ctx.prev = 10;
                            _ctx.t0 = _ctx["catch"](2);
                            demandStatus.value = DemandStatus.Fail;
                        case 13:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        2,
                        10
                    ]
                ]);
            }));
            return function getDemandInfoById() {
                return _ref.apply(this, arguments);
            };
        }();
        // let timer: null | ReturnType<typeof setTimeout> = null
        // const ThrottlingDuration = 500
        // watch(
        //   () => dialogValue.id,
        //   () => {
        //     if (timer) {
        //       clearTimeout(timer)
        //     }
        //     timer = setTimeout(() => {
        //       getDemandInfoById()
        //     }, ThrottlingDuration)
        //   },
        // )
        var dialogItemList = computed(function() {
            return [
                {
                    label: "\u9700\u6C42 ID",
                    type: "input",
                    prop: "id",
                    subtype: "number",
                    rules: [
                        {
                            required: true,
                            message: "\u9700\u6C42 ID\u4E0D\u80FD\u4E3A\u7A7A",
                            trigger: "blur"
                        },
                        {
                            validator: getDemandInfoById,
                            trigger: "blur"
                        }, 
                    ]
                },
                {
                    visible: demandStatus.value === DemandStatus.Success,
                    label: "\u63D0\u9700",
                    type: "plain-text",
                    prop: "demander_name"
                },
                {
                    visible: demandStatus.value === DemandStatus.Success,
                    label: "AM",
                    type: "plain-text",
                    prop: "account_manager_name"
                },
                {
                    visible: demandStatus.value === DemandStatus.Success,
                    label: "\u7B56\u5212\u5E08",
                    type: "plain-text",
                    prop: "planner_name"
                },
                {
                    visible: demandStatus.value === DemandStatus.Success,
                    label: "\u8BBE\u8BA1\u5E08",
                    type: "plain-text",
                    prop: "designer_name"
                },
                {
                    visible: demandStatus.value === DemandStatus.Success,
                    label: "\u7814\u53D1",
                    type: "plain-text",
                    prop: "developer_name"
                },
                {
                    visible: demandStatus.value === DemandStatus.Success,
                    label: "\u5E7F\u544A\u4E3B",
                    type: "plain-text",
                    prop: "adv_name"
                },
                {
                    visible: demandStatus.value === DemandStatus.Success,
                    label: "\u4E1A\u52A1\u573A\u666F",
                    type: "plain-text",
                    prop: "biz_scenario_name"
                },
                {
                    visible: demandStatus.value === DemandStatus.Success,
                    type: "plain-text",
                    prop: "tips"
                }, 
            ];
        });
        var submitDemandById = function() {
            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(id) {
                var res;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            dialogConfig.loading = true;
                            loading.value = true;
                            _ctx.prev = 2;
                            _ctx.next = 5;
                            return submitDemand({
                                id: id,
                                source: props.source,
                                project_id: props.projectId
                            });
                        case 5:
                            res = _ctx.sent;
                            if (res.data.code === 0) {
                                if (dialogConfig.visible) {
                                    dialogConfig.visible = false;
                                }
                                Message.success("\u64CD\u4F5C\u6210\u529F");
                                emit("updateBindDemand", {
                                    id: Number(dialogValue.id),
                                    status: "dev_ongoing",
                                    submit_status: "pending"
                                });
                                demandResultByIdPoll();
                            }
                            _ctx.next = 12;
                            break;
                        case 9:
                            _ctx.prev = 9;
                            _ctx.t0 = _ctx["catch"](2);
                            console.error(_ctx.t0);
                        case 12:
                            _ctx.prev = 12;
                            dialogConfig.loading = false;
                            loading.value = false;
                            return _ctx.finish(12);
                        case 16:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        2,
                        9,
                        12,
                        16
                    ]
                ]);
            }));
            return function submitDemandById(id) {
                return _ref.apply(this, arguments);
            };
        }();
        function getDemandResultById() {
            return _getDemandResultById.apply(this, arguments);
        }
        function _getDemandResultById() {
            _getDemandResultById = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
                var res;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            if (!(props.demandId === 0)) {
                                _ctx.next = 2;
                                break;
                            }
                            return _ctx.abrupt("return");
                        case 2:
                            _ctx.prev = 2;
                            _ctx.next = 5;
                            return getDemandResult({
                                source: props.source,
                                project_id: props.projectId
                            });
                        case 5:
                            res = _ctx.sent;
                            if (res.data.code === 0) {
                                demandTable.value = res.data.data.tasks;
                                demandTableMessage.value = res.data.data.message;
                                if (res.data.data.progress) {
                                    demandProgress.value = "\u8FDB\u5EA6\uFF1A".concat(res.data.data.progress);
                                } else {
                                    demandProgress.value = "";
                                }
                                if (res.data.data.status === "completed" && !dialogTableConfig.visible) {
                                    successMessage === null || successMessage === void 0 ? void 0 : successMessage.close();
                                    successMessage = Message({
                                        type: "success",
                                        showClose: true,
                                        duration: 0,
                                        message: "\u63D0\u6D4B\u6210\u529F"
                                    });
                                } else if (res.data.data.status === "failed" && !dialogTableConfig.visible) {
                                    // 异步任务失败提示
                                    if (demandTableMessage.value) {
                                        errorMessage === null || errorMessage === void 0 ? void 0 : errorMessage.close();
                                        errorMessage = Message({
                                            type: "warning",
                                            showClose: true,
                                            duration: 0,
                                            message: "".concat(demandTableMessage.value)
                                        });
                                    }
                                }
                                // 异步任务成功或失败停止轮询
                                if (res.data.data.status === "failed" || res.data.data.status === "completed") {
                                    if (getDemandResultTimer) {
                                        clearInterval(getDemandResultTimer);
                                        getDemandResultTimer = null;
                                    }
                                }
                            }
                            _ctx.next = 12;
                            break;
                        case 9:
                            _ctx.prev = 9;
                            _ctx.t0 = _ctx["catch"](2);
                            console.error(_ctx.t0);
                        case 12:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        2,
                        9
                    ]
                ]);
            }));
            return _getDemandResultById.apply(this, arguments);
        }
        var handleCommand = function(val) {
            if (val === 1) {
                dialogConfig.visible = true;
            } else if (val === 2 || val === 3) {
                submitDemandById(props.demandId);
            } else if (val === 4) {
                dialogTableConfig.visible = true;
                if (demandTable.value.length > 0) return;
                demandResultByIdPoll();
            }
        };
        var handleSubmit = function() {
            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            if (!(dialogValue.status !== "dev_ongoing")) {
                                _ctx.next = 3;
                                break;
                            }
                            Message.error("\u8BE5\u9700\u6C42\u72B6\u6001\u4E0D\u4E3A\u7814\u53D1\u4E2D\uFF0C\u65E0\u6CD5\u5173\u8054");
                            return _ctx.abrupt("return");
                        case 3:
                            if (!(dialogValue.biz_scenario === 4)) {
                                _ctx.next = 6;
                                break;
                            }
                            Message.error("\u65E0\u6CD5\u5173\u8054\u975E\u4ED3\u5E93\u5236\u4F5C\u7684\u9700\u6C42");
                            return _ctx.abrupt("return");
                        case 6:
                            _ctx.next = 8;
                            return submitDemandById(Number(dialogValue.id));
                        case 8:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function handleSubmit() {
                return _ref.apply(this, arguments);
            };
        }();
        return {
            dialogConfig: dialogConfig,
            dialogTableConfig: dialogTableConfig,
            demandTable: demandTable,
            dialogValue: dialogValue,
            dialogItemList: dialogItemList,
            dialogFormConfig: dialogFormConfig,
            bindProjectButton: bindProjectButton,
            handleSubmit: handleSubmit,
            handleCommand: handleCommand,
            demandTableMessage: demandTableMessage,
            demandProgress: demandProgress,
            PtButtonTheme: PtButtonTheme,
            PtButtonType: PtButtonType
        };
    }
});
